import React from "react"
import { useSelector } from "react-redux"
import SEO from "../components/seo"
import { endPoint } from "../state/config"

const StaticAssetPage = ({ name }) => {
  const jwt = useSelector(state => state.user.jwt)
  const base = endPoint.replace(/\/+$/, '')
  const src = `${base}/assets/${encodeURIComponent(name)}?token=${encodeURIComponent(jwt)}`

  return (
    <main className="main-iframe">
      <SEO title={name} />
      <iframe className="iframe" src={src} width="100%" title={name} />
    </main>
  )
}

export default StaticAssetPage
